﻿$.fn.dxCtrlCompteEmailConfigEnvoi = function custom_dxCtrlCompteEmailConfigEnvoi(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcompteemailconfigenvoi dx-ctrl");
        this.createInstance(new cdxCtrlCompteEmailConfigEnvoi(this, option));
    }
    return this;
}

window.cdxCtrlCompteEmailConfigEnvoi = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dxCtrlSwitchActif = null
    var newPassword = null

    this.hasChange = false
    var isLogged = false

    var $DivNeedVerif = null
    function mConstruit() {
        container.empty();

        if (typeof option.jauge == 'undefined') { option.jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance") }

        if (option.dataCompteEmail.id_utilisateur != option.dataCompteEmailUtilisateur.id_utilisateur && !isLogged) {
            //l'utilisateur courant ne gère pas ce compte mail
            //il est juste abonné
            //on demande le mot de passe de l'utilisateur qui est abonné
            container.css("text-align", "center")
            var objUti = option.bddCtrl.getObjet(option.bddCtrl.mGetArray("utilisateur").filter(function (o) { return o.id_utilisateur == option.dataCompteEmail.id_utilisateur })[0])
            $("<div>Cette adresse email est gérée par l'utilisateur <b>" + objUti.mGetLib1() + "</b>.<br/>Veuillez saisir son mot de passe pour accéder à l'interface de configuration de réception.</div>").appendTo(container)
            $("<br/>").appendTo(container)
            var dtxTextBoxPwd = $("<div style='display:inline-block'/>").appendTo(container).dxCtrlTextBox({
                width: 330,
                labelMode: 'floating',
                label: "Saisissez le mot de passe de l'utilisateur",
                value: option.value,
                showClearButton: false,
                placeholder: "Mot de passe",
                maxLength: 100,
                buttons: [{
                    focusStateEnabled: false,
                    name: 'showpwd',
                    location: 'after',
                    options: {
                        icon: 'eyeopen',
                        hint: "Révéler/cacher le texte",
                        focusStateEnabled: false,
                        stylingMode: 'text',
                        onClick() {
                            if (dtxTextBoxPwd.element().find("input").hasClass("txtPassword")) {
                                if (dtxTextBoxPwd.option("value") != null && dtxTextBoxPwd.option("value").contains("xxxxx")) {
                                    //Le mot de passe est en mémoire et ne peut être révélé
                                    dtxTextBoxPwd.option("value", "")
                                    mNotify("Le mot de passe en mémoire ne peut être révélé.<br/>Celui-ci a été retiré.<br/>Vous pouvez maintenant saisir votre nouveau mot de passe", "warning", 6000)
                                }
                                dtxTextBoxPwd.element().find("input").removeClass("txtPassword")
                            } else {
                                dtxTextBoxPwd.element().find("input").addClass("txtPassword")
                            }
                        },
                    },
                }],
                onContentReady: function (e) {
                    e.component.element().find("input").addClass("txtPassword")
                }
            }).dxCtrlTextBox("instance")
            $("<br/>").appendTo(container)
            $("<br/>").appendTo(container)
            $("<div/>").appendTo(container).dxCtrlButton({
                text: "Valider",
                onClick: function (e) {
                    if (dtxTextBoxPwd.option("value") == null || dtxTextBoxPwd.option("value").length == 0) {
                        if (objUti.data.is_robot == "1") {
                            isLogged = true;
                            mConstruit()
                        } else {
                            mNotify("Veuillez saisir le mot de passe de l'utilisateur.", "warning", 6000)
                            dtxTextBoxPwd.focus()
                        }
                    } else {
                        option.bddCtrl.mAjaxCall({ command: "verifutipwd", email: objUti.data.adresse_email, pwd: dtxTextBoxPwd.option("value") }, function (data) {
                            if (data.pwdok == "1") {
                                isLogged = true;
                                mConstruit()
                            } else {
                                mNotify("Le mot de passe est erroné.", "warning", 6000)
                                dtxTextBoxPwd.focus()
                            }
                        })
                    }
                }
            }).dxCtrlButton("instance")
        } else {
            container.css("text-align", "left")
            var $Table = $("<table style='width:100%;padding-bottom:20px;'/>").appendTo(container)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:1px;vertical-align:middle;'/>").appendTo($Tr)
            var disableChangeSwitch = false
            dxCtrlSwitchActif = $("<div/>").appendTo($Td).dxCtrlSwitch({
                width: 55,
                value: (option.dataCompteEmail.envoi_actif == "1"),
                focusStateEnabled: false,
                onValueChanged: function (e) {
                    if (disableChangeSwitch) return
                    if (e.value) {
                        if (option.dataCompteEmail.type_token_oauth != null && option.dataCompteEmail.type_token_oauth.length > 0) {
                            //on a déjà un token
                            mValideChange()
                        } else {
                            $("<div/>").appendTo("body").dxCtrlConfigPopupSmtp({
                                bddCtrl: option.bddCtrl,
                                value: {
                                    adresse_email: option.dataCompteEmail.adresse_email,
                                    envoi_login: option.dataCompteEmail.envoi_login,
                                    envoi_serveur: option.dataCompteEmail.envoi_serveur,
                                    envoi_port: option.dataCompteEmail.envoi_port,
                                    envoi_ssl: option.dataCompteEmail.envoi_ssl,
                                    envoi_pwd: ((option.dataCompteEmail.envoi_pwd == null) ? "" : option.dataCompteEmail.envoi_pwd)
                                },
                                onValide: function (value) {
                                    Me.hasChange = true;
                                    option.dataCompteEmail.envoi_login = value.envoi_login
                                    option.dataCompteEmail.envoi_serveur = value.envoi_serveur
                                    option.dataCompteEmail.envoi_port = value.envoi_port
                                    option.dataCompteEmail.envoi_ssl = value.envoi_ssl
                                    option.dataCompteEmail.envoi_pwd = value.envoi_pwd
                                    mValideChange()
                                },
                                onCancel: function () {
                                    Me.mCancel()
                                    //disableChangeSwitch = true
                                    //dxCtrlSwitchActif.option("value", false)
                                    //disableChangeSwitch = false
                                },
                                onDemandeClosePopupParent: option.onDemandeClosePopupParent,
                                onDemandeConnexionOauthGmail: option.onDemandeConnexionOauthGmail
                            })
                        }
                        //var domaine = option.dataCompteEmail.adresse_email.split("@")[1]
                        //if (parametre.domaineSpam.filter(function (o) { return o.provider == "Gmail" && o.domain.contains("@" + domaine.toLowerCase()) }).length > 0) {
                        //    //on est sur un compte gmail
                        //    if (option.dataCompteEmail.access_token_oauth != null && option.dataCompteEmail.access_token_oauth.length > 0) {
                        //        //on a déjà un token
                        //        mValideChange()
                        //    } else {
                        //        disableChangeSwitch = true
                        //        e.component.option("value", false)
                        //        disableChangeSwitch = false
                        //        mCreateTokenEmailGmail({
                        //            bddCtrl: option.bddCtrl,
                        //            onStart: function () { },
                        //            onValide: function (dataCompteEmail, dataCompteEmailUtilisateur) {
                        //                option.dataCompteEmail = dataCompteEmail
                        //                option.dataCompteEmailUtilisateur = dataCompteEmailUtilisateur
                        //                option.dataCompteEmail.envoi_actif = "1"
                        //                option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("envoi_actif", function (data) {
                        //                    if (typeof option.onDemandeReloadForOAuth != 'undefined') option.onDemandeReloadForOAuth()
                        //                })
                        //            }
                        //        })
                        //    }
                        //} else {
                        //    $("<div/>").appendTo("body").dxCtrlConfigPopupSmtp({
                        //        bddCtrl: option.bddCtrl,
                        //        value: {
                        //            adresse_email: option.dataCompteEmail.adresse_email,
                        //            envoi_login: option.dataCompteEmail.envoi_login,
                        //            envoi_serveur: option.dataCompteEmail.envoi_serveur,
                        //            envoi_port: option.dataCompteEmail.envoi_port,
                        //            envoi_ssl: option.dataCompteEmail.envoi_ssl,
                        //            envoi_pwd: ((option.dataCompteEmail.envoi_pwd == null) ? "" : option.dataCompteEmail.envoi_pwd)
                        //        },
                        //        onValide: function (value) {
                        //            Me.hasChange = true;
                        //            option.dataCompteEmail.envoi_login = value.envoi_login
                        //            option.dataCompteEmail.envoi_serveur = value.envoi_serveur
                        //            option.dataCompteEmail.envoi_port = value.envoi_port
                        //            option.dataCompteEmail.envoi_ssl = value.envoi_ssl
                        //            option.dataCompteEmail.envoi_pwd = value.envoi_pwd
                        //            mValideChange()
                        //        },
                        //        onCancel: function () {
                        //            disableChangeSwitch = true
                        //            dxCtrlSwitchActif.option("value", false)
                        //            disableChangeSwitch = false
                        //        },
                        //        onDemandeClosePopupParent: option.onDemandeClosePopupParent,
                        //        onDemandeConnexionOauthGmail: option.onDemandeConnexionOauthGmail
                        //    })
                        //}
                    } else {
                        mValideChange()
                    }

                    function mValideChange() {
                        Me.hasChange = true;
                        option.dataCompteEmail.envoi_actif = ((e.value) ? "1" : "0")
                        option.dataCompteEmail.message_smtp_off = ((e.value) ? "1" : "0")
                        option.dataCompteEmail.envoi_derniere_erreur_cnx = ""
                        if (option.allowSave) {
                            option.jauge.mShow()
                            if (option.dataCompteEmail.id_compte_email == null) {
                                option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("message_smtp_off", function (data) {
                                    option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("envoi_derniere_erreur_cnx", function (data) {
                                        option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("envoi_actif", function (data) {
                                            option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("envoi_login", function (data) {
                                                option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("envoi_serveur", function (data) {
                                                    option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("envoi_port", function (data) {
                                                        option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("envoi_ssl", function (data) {
                                                            option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("envoi_pwd", function (data) {
                                                                if (typeof option.onChange != 'undefined') option.onChange(option.dataCompteEmail)
                                                                $TdSwitchLib.css("opacity", ((option.dataCompteEmail.envoi_actif == "1") ? "1" : "0.2"))
                                                                option.jauge.mHide()
                                                                mConstruit()
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    })
                                })
                            } else {
                                if (option.dataCompteEmail.type_token_oauth != null && option.dataCompteEmail.type_token_oauth.length > 0) {
                                    option.bddCtrl.mAjaxCall({
                                        command: "savecompteemailenvoi",
                                        id_compte_email: option.dataCompteEmail.id_compte_email,
                                        message_smtp_off: option.dataCompteEmail.message_smtp_off,
                                        envoi_derniere_erreur_cnx: option.dataCompteEmail.envoi_derniere_erreur_cnx,
                                        envoi_actif: option.dataCompteEmail.envoi_actif
                                    }, function (data) {
                                        option.bddCtrl.triggerFunctionOnModifiedItemData("compte_email", "modif", option.dataCompteEmail)
                                        if (typeof option.onChange != 'undefined') option.onChange(option.dataCompteEmail)
                                        $TdSwitchLib.css("opacity", ((option.dataCompteEmail.envoi_actif == "1") ? "1" : "0.2"))
                                        option.jauge.mHide()
                                        mConstruit()
                                    })
                                } else {
                                    option.bddCtrl.mAjaxCall({
                                        command: "savecompteemailenvoi",
                                        id_compte_email: option.dataCompteEmail.id_compte_email,
                                        message_smtp_off: option.dataCompteEmail.message_smtp_off,
                                        envoi_derniere_erreur_cnx: option.dataCompteEmail.envoi_derniere_erreur_cnx,
                                        envoi_actif: option.dataCompteEmail.envoi_actif,
                                        envoi_login: option.dataCompteEmail.envoi_login,
                                        envoi_serveur: option.dataCompteEmail.envoi_serveur,
                                        envoi_port: option.dataCompteEmail.envoi_port,
                                        envoi_ssl: option.dataCompteEmail.envoi_ssl,
                                        envoi_pwd: option.dataCompteEmail.envoi_pwd
                                    }, function (data) {
                                        option.bddCtrl.triggerFunctionOnModifiedItemData("compte_email", "modif", option.dataCompteEmail)
                                        if (typeof option.onChange != 'undefined') option.onChange(option.dataCompteEmail)
                                        $TdSwitchLib.css("opacity", ((option.dataCompteEmail.envoi_actif == "1") ? "1" : "0.2"))
                                        option.jauge.mHide()
                                        mConstruit()
                                    })
                                }
                            }
                        } else {
                            //if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("envoi_actif");
                            if (typeof option.onChange != 'undefined') option.onChange(option.dataCompteEmail)
                            $TdSwitchLib.css("opacity", ((option.dataCompteEmail.envoi_actif == "1") ? "1" : "0.2"))
                            mConstruit()
                        }
                    }
                }
            }).dxCtrlSwitch("instance")
            var $TdSwitchLib = $("<td style='width:100%;padding-left:10px;vertical-align:middle;opacity:" + ((option.dataCompteEmail.envoi_actif == "1") ? "1" : "0.2") + ";'>Utiliser le SMTP de l'adresse pour les envois</td>").appendTo($Tr)

            if (option.dataCompteEmail.envoi_actif == "0") {
                $("<div style='color:orange;font-weight:bold;'>Vous n'avez pas activé le SMTP de votre adresse email pour les envois quotidiens.</div>").appendTo(container)
                var domaine = option.dataCompteEmail.adresse_email.split("@")[1]
                if (parametre.domaineSpam.filter(function (o) { return o.provider == "Gmail" && o.domain.contains("@" + domaine.toLowerCase()) }).length > 0) {
                    //on est sur un compte gmail
                } else {
                    $("<div style='color:orange;font-weight:bold;'>Nous vous recommandons de configurer le SMTP pour vos envois quotidiens pour vous assurer une délivrabilité optimale.<br/><br/></div>").appendTo(container)
                    $("<div style='color:orange;'/>").appendTo(container).dxCtrlCompteEmailConfigEnvoiDns({
                        bddCtrl: option.bddCtrl,
                        adresse_email: option.dataCompteEmail.adresse_email,
                        dataCompteEmail: option.dataCompteEmail,
                        noDNS: true,
                        showDelivrabilite: false,
                        envoiQuotidien: true,
                        allowSave: option.allowSave
                    })
                }
            } else {
                var items = [];
                items.push({
                    label: { visible: false, text: "login", location: "left" },
                    template: function (itemData, itemElement) {
                        var $Div = $("<div style='margin:0;padding:10px;border:" + theme.border + ";'/>").appendTo(itemElement)
                        if (option.dataCompteEmail.type_token_oauth != null && option.dataCompteEmail.type_token_oauth.length > 0) {
                            $("<div>Vous êtes connecté via <b>OAuth</b>. L’accès à votre boîte mail est sécurisé : votre mot de passe n’est jamais stocké ni partagé.</div>").appendTo($Div)
                            var $Table = $("<table style='margin-bottom:5px;'/>").appendTo($Div)
                            var $Tr = $("<tr/>").appendTo($Table)
                            var $Td = $("<td style='width:100%;opacity:0.5;'></td>").appendTo($Tr)
                            var $Td = $("<td style='width:1px;padding-right:15px;'></td>").appendTo($Tr)
                            var $A = $("<a href='javascript:void(0)'>Tester</a>").appendTo($Td)
                            $A.on("click", function (e) {
                                mTestConnexionOauth()
                            })
                            var $Td = $("<td style='width:1px;'></td>").appendTo($Tr)
                            var $A = $("<a href='javascript:void(0)'>Déconnecter</a>").appendTo($Td)
                            $A.on("click", function () {
                                option.dataCompteEmail.access_token_oauth = null
                                option.dataCompteEmail.refresh_token_oauth = null
                                option.dataCompteEmail.access_token_oauth_crypt = null
                                option.dataCompteEmail.refresh_token_oauth_crypt = null
                                option.dataCompteEmail.type_token_oauth = null
                                option.dataCompteEmail.envoi_actif = "0"
                                option.dataCompteEmail.reception_actif = "0"
                                option.bddCtrl.getObjet(option.dataCompteEmail).mSave(function (data) {
                                    if (typeof option.onDemandeReloadForOAuth != 'undefined') option.onDemandeReloadForOAuth()
                                })
                            })
                        } else {
                            var $Table = $("<table style='margin-bottom:5px;'/>").appendTo($Div)
                            var $Tr = $("<tr/>").appendTo($Table)
                            var $Td = $("<td style='width:100%;opacity:0.5;'>Configuration de votre SMTP</td>").appendTo($Tr)
                            var $Td = $("<td style='width:1px;padding-right:15px;'></td>").appendTo($Tr)
                            var $A = $("<a href='javascript:void(0)'>Tester</a>").appendTo($Td)
                            $A.on("click", function (e) {
                                mTestConnexionSmtp()
                            })
                            var $Td = $("<td style='width:1px;'></td>").appendTo($Tr)
                            var $A = $("<a href='javascript:void(0)'>Modifier</a>").appendTo($Td)
                            $A.on("click", function (e) {
                                $("<div/>").appendTo("body").dxCtrlConfigPopupSmtp({
                                    bddCtrl: option.bddCtrl,
                                    value: {
                                        adresse_email: option.dataCompteEmail.adresse_email,
                                        envoi_login: option.dataCompteEmail.envoi_login,
                                        envoi_serveur: option.dataCompteEmail.envoi_serveur,
                                        envoi_port: option.dataCompteEmail.envoi_port,
                                        envoi_ssl: option.dataCompteEmail.envoi_ssl,
                                        envoi_pwd: ((option.dataCompteEmail.envoi_pwd == null) ? "" : option.dataCompteEmail.envoi_pwd)
                                    },
                                    onValide: function (value) {
                                        Me.hasChange = true;
                                        option.dataCompteEmail.envoi_login = value.envoi_login
                                        option.dataCompteEmail.envoi_serveur = value.envoi_serveur
                                        option.dataCompteEmail.envoi_port = value.envoi_port
                                        option.dataCompteEmail.envoi_ssl = value.envoi_ssl
                                        option.dataCompteEmail.envoi_pwd = value.envoi_pwd
                                        if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmail).mSave()
                                    },
                                    onDemandeClosePopupParent: option.onDemandeClosePopupParent
                                })
                            })
                            $("<div style='padding-left:20px;'><span style='opacity:0.5'>Login: </span>" + option.dataCompteEmail.envoi_login + "</div>").appendTo($Div)
                            $("<div style='padding-left:20px;'><span style='opacity:0.5'>Serveur: </span>" + option.dataCompteEmail.envoi_serveur + "</div>").appendTo($Div)
                            $("<div style='padding-left:20px;'><span style='opacity:0.5'>Port: </span>" + option.dataCompteEmail.envoi_port + "</div>").appendTo($Div)
                            $("<div style='padding-left:20px;'><span style='opacity:0.5'>SSL: </span>" + ((option.dataCompteEmail.envoi_ssl == "1") ? "OUI" : "NON") + "</div>").appendTo($Div)
                        }
                    },
                    colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
                })

                var $DivForm = $("<div style='position:relative;'/>").appendTo(container)
                var form = $("<div style='padding:0 65px;'/>").appendTo($DivForm).dxCtrlForm({
                    labelMode: 'floating',
                    showColonAfterLabel: true,
                    labelLocation: 'left',
                    items: items
                }).dxCtrlForm("instance");
            }

            //if (option.bddCtrl.baseAppli.code_appli == "ppmasc" || option.bddCtrl.nom_base.endsWith("_aagest")) {

            var $Table = $("<table style='padding-top:10px;'/>").appendTo(container)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:130px;padding:0 10px 0 10px;text-align:right;'></td>").appendTo($Tr)
            $("<div/>").appendTo($Td).appendTo($Td).dxCtrlSwitch({
                width: 55,
                value: (option.dataCompteEmail.envoi_temporisation_mn != null),
                focusStateEnabled: false,
                onValueChanged: function (e) {
                    option.dataCompteEmail.envoi_temporisation_mn = ((e.value) ? "3" : null)
                    dxSelectTempo.option("value", option.dataCompteEmail.envoi_temporisation_mn)
                    if (e.value) { $TableTempoEnvoi.slideDown(500) } else { $TableTempoEnvoi.slideUp(500) }
                    //if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("envoi_temporisation_mn")
                }
            })
            var $Td = $("<td style='width:100%;text-align:left;line-height:1;'>Temporisation de vos envois<br/><i style='font-size:80%;'>Définissez un temps de temporisation de vos envois (en minute). Vos emails seront envoyées X minutes aprés la date effective d'envoi (ce paramètre impacte aussi vos emailing envoyé via cette adresse email).</i></td>").appendTo($Tr)

            var dxSelectTempo = null
            var $TableTempoEnvoi = $("<table style='" + ((option.dataCompteEmail.envoi_temporisation_mn != null) ? "" : "display:none") + ";padding-top:5px;'/>").appendTo(container)
            //Jour envoi
            var $Tr = $("<tr/>").appendTo($TableTempoEnvoi)
            var $Td = $("<td style='white-space:nowrap;width:130px;opacity:0.2;padding:0 10px 0 10px;text-align:right;'>Minute de temporisation</td>").appendTo($Tr)
            var $Td = $("<td style='white-space:nowrap;width:100%;text-align:left;'/>").appendTo($Tr)
            dxSelectTempo = $("<div style='display:inline-block'/>").appendTo($Td).dxSelectBox({
                labelMode: 'floating',
                label: "Nbre de minutes:",
                dataSource: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
                value: ((option.dataCompteEmail.envoi_temporisation_mn == null) ? null : option.dataCompteEmail.envoi_temporisation_mn.toString()),
                onValueChanged: function (e) {
                    option.dataCompteEmail.envoi_temporisation_mn = e.value
                    if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("envoi_temporisation_mn")
                }
            }).dxSelectBox("instance")





            var $Table = $("<table style='padding-top:20px;'/>").appendTo(container)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:130px;padding:0 10px 0 10px;text-align:right;'></td>").appendTo($Tr)
            $("<div/>").appendTo($Td).appendTo($Td).dxCtrlSwitch({
                width: 55,
                value: (option.dataCompteEmail.envoi_has_horaire == "1"),
                focusStateEnabled: false,
                onValueChanged: function (e) {
                    option.dataCompteEmail.envoi_has_horaire = ((e.value) ? "1" : "0")
                    if (e.value) { $TableDetailHoraire.slideDown(500) } else { $TableDetailHoraire.slideUp(500) }
                    if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("envoi_has_horaire")
                }
            })
            var $Td = $("<td style='width:100%;text-align:left;line-height:1;'>Jours et horaire des envois<br/><i style='font-size:80%;'>Définissez la plage ou pourront-être envoyé vos messages. En dehors de ces horaires, vos emails seront mis en attente (ce paramètre impacte aussi vos emailing envoyé via cette adresse email).</i></td>").appendTo($Tr)

            var $TableDetailHoraire = $("<table style='" + ((option.dataCompteEmail.envoi_has_horaire == "1") ? "" : "display:none") + "'/>").appendTo(container)
            //Jour envoi
            var $Tr = $("<tr/>").appendTo($TableDetailHoraire)
            var $Td = $("<td style='white-space:nowrap;width:130px;opacity:0.2;padding:0 10px 0 10px;text-align:right;'>Jours envois</td>").appendTo($Tr)
            var $Td = $("<td style='white-space:nowrap;width:100%;text-align:left;'/>").appendTo($Tr)
            $("<div style='display:inline-block'/>").appendTo($Td).dxCtrlSelectJour({
                label: "",
                value: option.dataCompteEmail.envoi_jour,
                onValueChanged: function (e) {
                    option.dataCompteEmail.envoi_jour = e.value
                    if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("envoi_jour")
                }
            }).find(".dx-ctrllstcheckbox").css("padding-top", "0").css("min-height", "0")
            //Jour férie
            var $Tr = $("<tr/>").appendTo($TableDetailHoraire)
            var $Td = $("<td style='white-space:nowrap;width:130px;opacity:0.2;padding:0 10px 0 10px;text-align:right;'>Hors jours fériés</td>").appendTo($Tr)
            var $Td = $("<td style='white-space:nowrap;width:100%;text-align:left;padding:0 16px;'/>").appendTo($Tr)
            $("<div style='display:inline-block'/>").appendTo($Td).dxCtrlCheckBox({
                text: "(Actuellement, " + ((option.dataCompteEmail.envoi_hors_ferie == "1") ? "aucun envoi pendant les jours fériés)" : "envoi pendant les jours fériés)"),
                value: (option.dataCompteEmail.envoi_hors_ferie == "1"),
                onValueChanged: function (e) {
                    option.dataCompteEmail.envoi_hors_ferie = ((e.value) ? "1" : "0")
                    e.component.option("text", "(Actuellement, " + ((option.dataCompteEmail.envoi_hors_ferie == "1") ? "aucun envoi pendant les jours fériés)" : "envoi pendant les jours fériés)"))
                    if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("envoi_hors_ferie")
                }
            })
            //horaire envoi
            var $Tr = $("<tr/>").appendTo($TableDetailHoraire)
            var $Td = $("<td style='white-space:nowrap;width:130px;opacity:0.2;padding:0 10px 0 10px;text-align:right;'>Horaire envois</td>").appendTo($Tr)
            var $Td = $("<td style='white-space:nowrap;width:100%;text-align:right;'/>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlLstTimeBoxInterval({
                value: option.dataCompteEmail.envoi_horaire,
                intervalMn: 30,
                onValueChanged: function (e) {
                    option.dataCompteEmail.envoi_horaire = e.value
                    if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("envoi_horaire")
                }
            })

            //nbr max envoi par jour
            var $Table = $("<table style='padding-top:20px;'/>").appendTo(container)
            $Table.attr("title","Votre fournisseur de messagerie limite le nombre de destinataires auxquels vous pouvez envoyer des e-mails, généralement de quelques centaines à quelques milliers par jour selon votre compte. En cas de dépassement, vos envois peuvent être temporairement bloqués. Vérifiez auprès de votre hébergeur.<br/>Ce paramètre vous permet d'être averti lorsque vous approchez ou dépassez cette limite, afin de pouvoir prendre les mesures nécessaires.")
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='white-space:nowrap;width:130px;opacity:0.6;padding:0 10px 0 10px;text-align:right;'>Nbre envois autorisé par jour</td>").appendTo($Tr)
            var $Td = $("<td style='white-space:nowrap;width:100%;text-align:right;'/>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlNumberBox({
                value: option.dataCompteEmail.envoi_nb_email_smtp_jour,
                min: 50,
                onValueChanged: function (e) {
                    option.dataCompteEmail.envoi_nb_email_smtp_jour = (e.value == null ? 100 : e.value)
                    if (option.allowSave) option.bddCtrl.getObjet(option.dataCompteEmail).mSaveChamp("envoi_nb_email_smtp_jour")
                }
            })
            //}

            //if (option.showDelivrabilite) {
            //    $("<div style='margin-top:20px;'/>").appendTo(container).dxCtrlCompteEmailTestDelivrabilite({
            //        bddCtrl: option.bddCtrl,
            //        type: "smtp_email",
            //        dataCompteEmail: option.dataCompteEmail,
            //        ssTitle: "de vos envois quotidien"
            //    })
            //}

        }
    }


    this.mCancel = function () {
        disableChangeSwitch = true
        dxCtrlSwitchActif.option("value", false)
        disableChangeSwitch = false
    }

    function mTestConnexionOauth() {
        option.jauge.mShow()
        var reqAjax = option.bddCtrl.mAjaxCall({
            command: "testemailoauth",
            id_compte_email: option.dataCompteEmail.id_compte_email
        }, function (data) {
            if (typeof data.message_erreur != 'undefined' && data.message_erreur.length > 0) {
                mNotify("Votre connexion oauth ne fonctionne plus<br>Pour réactiver votre connexion, déconnecter vous et reconnecter vous au service.<br/><i>" + data.message_erreur + "</i>", "error", 12000)
            } else {
                mNotify("Votre connexion oauth est active", "success", 12000)
            }
            option.jauge.option("message", null)
            option.jauge.option("onCancel", null)
        }, function () {
            option.jauge.option("message", null)
            option.jauge.option("onCancel", null)
            option.jauge.mHide()
        });
    }

    function mTestConnexionSmtp() {
        option.jauge.mShow()
        var reqAjax = option.bddCtrl.mAjaxCall({
            command: "testemailsmtp",
            server: option.dataCompteEmail.envoi_serveur,
            port: option.dataCompteEmail.envoi_port,
            ssl: (option.dataCompteEmail.envoi_ssl ? "1" : "0"),
            login: option.dataCompteEmail.envoi_login,
            adresse_email: option.dataCompteEmail.adresse_email,
            pwd: option.dataCompteEmail.envoi_pwd,
            utilise_pwd_bdd: ((option.dataCompteEmail.envoi_pwd == null || option.dataCompteEmail.envoi_pwd.length == 0) ? "1" : "0")
        }, function (data) {
            if (typeof data.message_erreur != 'undefined') {
                var txt = ""
                if (!data.message_erreur.contains("(1265)")) {
                    txt = "<br/>Si vous ne connaissez pas la configuration de votre adresse email, demander à votre hébergeur les paramètres du SMTP de votre adresse email."
                }
                txt = "Les paramètres de connexion que vous avez saisie sont incorrecte:<br/>" + "&bull; " + data.message_erreur.replace(" (1265)", "") + txt
                if (typeof option.dataCompteEmail.envoi_serveur != 'undefined' && option.dataCompteEmail.envoi_serveur && option.dataCompteEmail.envoi_serveur.endsWith(".gmail.com")) {
                    txt += "<br/>Pour GMAIL, vous devez intervenir sur votre compte pour créer un mot de passe d'application. Ouvrez la configuration pouir modifer cela.</a>"
                }
                mNotify(txt, "error", 12000)
                dxCtrlSwitchActif.option("value", false)
            } else {
                mNotify("La configuration que vous avez saisie est correcte", "success", 12000)
            }
            option.jauge.option("message", null)
            option.jauge.option("onCancel", null)
        }, function () {
            option.jauge.option("message", null)
            option.jauge.option("onCancel", null)
            option.jauge.mHide()
        });
    }

    this.mSave = function (data) {
        option.bddCtrl.getObjet(data).mSave()
    }

    this.mMigreData = function (data) {
        data.envoi_login = option.dataCompteEmail.envoi_login
        if (newPassword) { data.envoi_pwd = newPassword; hasPassword = true; } else { delete data.envoi_pwd }
        newPassword = null
        data.envoi_serveur = option.dataCompteEmail.envoi_serveur
        data.envoi_port = option.dataCompteEmail.envoi_port
        data.envoi_ssl = option.dataCompteEmail.envoi_ssl
        data.envoi_pwd = option.dataCompteEmail.envoi_pwd
        data.envoi_actif = option.dataCompteEmail.envoi_actif
        this.hasChange = false
    }

    this.element = function () { return container }

    mConstruit();
}